import React from 'react';

const Loading: React.FC = () => {
  return <div className="mt-20 text-center text-4xl text-lime-600">Loading...</div>;
};

export default Loading;
